export default class FuzeGamesApp {
    constructor(api) {
        this.api = api;
        this.FuzeGamesAppClass = null;
    }

    async init(instance) {
        if (this.api && this.api.settings && this.api.settings.fuzeGamesAppInstance && this.api.settings.fuzeGamesAppInstance !== instance.instance) {
            return;
        }
        if (!this.FuzeGamesAppClass) {
            if (instance.data && instance.data.cdn && instance.data.cdn.js) {
    
                await this.api.util.loadJS(instance.data.cdn.js);
                
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileGame &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.fuzeGamesApp &&
                this.api.settings.widgetsUrl.fuzeGamesApp.js
            ) {
                await this.api.util.loadJS([this.api.settings.widgetsUrl.fuzeGamesApp.js]);
            }

            if (instance.data && instance.data.cdn && instance.data.cdn.css) {
                await this.api.util.loadCSS(instance.data.cdn.css);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileGame &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.fuzeGamesApp &&
                this.api.settings.widgetsUrl.fuzeGamesApp.css
            ) {
                await this.api.util.loadCSS([this.api.settings.widgetsUrl.fuzeGamesApp.css]);
            }
        }
        if (window.store) {
            window.store.dispatch('addInstanceToContainer', `${instance.instance}_app`)
            this.createInstance(instance)
        }
    }

    createInstance(instance) {
        if (!document.getElementById(`ox-drawer-instance-container-${instance.instance}_app-inner`)) {
            setTimeout(()=> {
                this.createInstance(instance)
            },100)
        } else {
            this.FuzeGamesAppClass = new window.Widget_fuzeGamesApp.default(this.api.settings, `#ox-drawer-instance-container-${instance.instance}_app-inner`, instance.instance, this.api);
        }
    }
}
